import { isValidNumber } from 'libphonenumber-js'
import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import "register/less/attribute.less"
import "register/less/mobile.less"
import "register/less/registration.less"
import Field from "shared/components/forms/field"

const MobileComponent = (props) => {
    const [isValid, setIsValid] = useState(false)
    const [checkBoxValid, setCheckBoxValid] = useState(false)
    const [isTouched, setIsTouched] = useState(false)
    const [sendEmails, setSendEmails] = useState(true)
    const [sendSms, setSendSms] = useState(true)
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [showSmsAndEmailError, setShowSmsAndEmailError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const { t } = useTranslation()

    const onlyCountries = [
        { name: t('form.mobile_us'), iso2: "us", dialCode: "1", format: "+. (...) ...-...." },
        { name: t('form.mobile_australia'), iso2: "au", dialCode: "61", format: "+.. ... ... ..." },
        { name: t('form.mobile_belgium'), iso2: "be", dialCode: "32", format: "+.. ... .. .. .." },
        { name: t('form.mobile_brazil'), iso2: "br", dialCode: "55", format: "+..-..-....-...." },
        { name: t('form.mobile_canada'), iso2: "ca", dialCode: "1", format: "+. (...) ...-....", hasAreaCodes: true },
        { name: t('form.mobile_china'), iso2: "cn", dialCode: "86", format: "+.. ..-........" },
        { name: t('form.mobile_france'), iso2: "fr", dialCode: "33", format: "+.. . .. .. .. .." },
        { name: t('form.mobile_germany'), iso2: "de", dialCode: "49", format: "+.. ... ......." },
        { name: t('form.mobile_india'), iso2: "in", dialCode: "91", format: "+.. .....-....." },
        { name: t('form.mobile_italy'), iso2: "it", dialCode: "39", format: "+.. ... ......" },
        { name: t('form.mobile_uk'), iso2: "gb", dialCode: "44", format: "+.. .... ......" },
        { name: t('form.mobile_spain'), iso2: "es", dialCode: "34", format: "+.. ... ... ..." },
    ]

    useEffect(() => {
        props.setMobileNumber(previousState => {
            if (previousState.value) {
                setMobileNumber(previousState.value)
                setIsValid(isValidPhoneNumber(previousState.value))
                return previousState
            }
            previousState.value = ""
            previousState.valid = false
            return previousState
        })
    }, [props.setMobileNumber])

    useEffect(() => {
        if (props.highlightErrors) {
            isValidPhoneNumber(mobileNumber)
            setShowSmsAndEmailError(true)
        }
    }, [props.highlightErrors])

    useEffect(() => {
        setEmailAndSms(sendEmails, sendSms)
    }, [props.setSendEmailAndSms])

    useEffect(() => {
        if (props.countryIsoCode === "us") {
            if (mobileNumber.length>2 && isValid) {
                setSendSms(true)
            } else {
                setSendSms(false)
             }
         }
    }, [mobileNumber, props.countryIsoCode])

    const isValidPhoneNumber = (value) => {
        setIsTouched(true)
        const valid = (props.countryIsoCode === "us" && value.length <= 2)? true : isValidNumber(value)
        const isEmpty = !value || value == "+" || value.length < 4
        if (isEmpty && !value.startsWith("+1")) {
            setErrorMessage(`${t("user.mobile_phone")} ${t("form.required")}`)
        } else if (!valid) {
                setErrorMessage(t("form.invalid_number"))
        }
        props.setMobileNumber(previousState => {
            previousState.value = value
            previousState.valid = valid
            return previousState
        })
        setShowErrorMessage(!valid)
        return valid
    }


    const setEmailAndSms = (emails, sms) => {
        props.setSendEmailAndSms((previousState) => {
            previousState.valid = validateEmailAndSms(emails, sms)
            previousState.sendEmails = emails
            previousState.sendSms = sms
            return previousState
        })
    }

    const validateEmailAndSms = (emails, sms) => {
        //Email checkbox is required for OS users
        const result = props.isShgRegistration ? emails : (emails || sms)
        setCheckBoxValid(result)
        return result
    }

    const onEmailCheckbox = () => {
        setSendEmails(previousState => {
            setEmailAndSms(!previousState, sendSms)
            return !previousState
        })
    }

    const onSmsCheckbox = () => {
        setSendSms(previousState => {
            setEmailAndSms(sendEmails, !previousState)
            return !previousState
        })
    }

    return (
        <div>
            <div className="attribute-container center-items">
                <Field
                    type="i18n-mobile"
                    label={t("user.mobile_phone")}
                    defaultCountry={props.countryIsoCode}
                    preferredCountries={[]}
                    name="Mobile Number"
                    onlyCountries={onlyCountries}
                    className={showErrorMessage && isTouched ? "input-choice error" : "input-choice"}
                    value={mobileNumber}
                    autoComplete="off"
                    onChange={(value) => {
                        setMobileNumber(value)
                        setIsValid(isValidPhoneNumber(value))
                    }}
                />
                 {((isValid && props.countryIsoCode !== "us") || (props.countryIsoCode === "us" && mobileNumber.length >2 && isValid)) && (
                    <i className="im-check check-icon" style={{ top: '30px' }} />
                )}
                 {showErrorMessage && isTouched && (
                    <p className="attribute-error-message attribute-error-message-text">{errorMessage}</p>
                )}
                {props.isShgRegistration === false && props.countryIsoCode === "us" && (
                <p className="text-start text-justify" style={{ marginTop: '10px', marginBottom: '7px' }}>
                {t("user.mobile_message_incrowd")} </p>
                )}
                {props.isShgRegistration === true && props.countryIsoCode === "us" && (
                <p className="text-start text-justify" style={{ marginTop: '15px', marginBottom: '7px' }}>
                  {t("user.mobile_message_OpinionSite")} </p>
                )}
            </div>
            {props.isShgRegistration === false && props.countryIsoCode === "us"&& (
    <hr style={{height: '5px',marginTop: '0px',marginBottom: '10px',paddingBottom: '1px',borderTopWidth: '1px',borderColor: 'black',width: '80%'}} />
)}
            { !props.isShgRegistration &&
            <div className="center-items">
                <div className="how-would-you-like-t">
                    {t('details.how_receive_surveys')}
                </div>
                <div className="surveys" id="receive-surverys">
                    <div id="email" className={showSmsAndEmailError && !checkBoxValid ? "tandc-error" : ""}>
                        <Field
                            name="Send Email"
                            type="checkbox"
                            label={t("user.email")}
                            id="accepted-email"
                            checked={sendEmails}
                            onChange={() => {
                                onEmailCheckbox()
                            }}
                            disabled={props.isShgRegistration}
                        />
                    </div>
                    <div id="sms" className={showSmsAndEmailError && !checkBoxValid ? "tandc-error" : "mobile-checkbox"}>
                        <Field
                            name="Send SMS"
                            type="checkbox"
                            label={t("user.mobile")}
                            id="accepted-mobile"
                            checked={sendSms}
                            onChange={() => {
                                onSmsCheckbox()
                            }}
                        />
                    </div>
                </div>
                {showSmsAndEmailError && !checkBoxValid && (
                    <div>
                        {!props.isShgRegistration && <p className="attribute-error-message attribute-error-message-text">{t('form.sms_email_validation')}</p>}
                        {props.isShgRegistration && <p className="attribute-error-message attribute-error-message-text">{t('form.email_validation')}</p>}
                    </div>
                )}
            </div>}
        </div>
    )
}

export default MobileComponent